/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React, {FunctionComponent} from 'react'
import {SkeletonTypes} from "../../atoms/effects/skeletons/utils/SkeletonTypes";
import {IWithSkeleton} from "../../../interfaces/my-puratos/hoc/IWithSkeleton";
import {ProductSkeleton} from "../atoms/effects/skeletons/products/ProductSkeleton";
import {OrderSkeleton} from "../atoms/effects/skeletons/orders/OrderSkeleton";
import {InvoiceSkeleton} from "../atoms/effects/skeletons/invoices/InvoiceSkeleton";
import {FavoriteRecipeSkeleton} from "../atoms/effects/skeletons/favorite-recipes/FavoriteRecipeSkeleton";
import {DocumentSkeleton} from "../atoms/effects/skeletons/documents/DocumentSkeleton";
import {ContractSkeleton} from "../atoms/effects/skeletons/contracts/ContractSkeleton";
import {CartSkeleton} from "../atoms/effects/skeletons/cart/CartSkeleton";
import {DeliveryNoteSkeleton} from "../atoms/effects/skeletons/delivery-notes/DeliveryNoteSkeleton";
import {RecipeListSkeleton} from "../../atoms/effects/skeletons/recipelist/RecipeListSkeleton";
import {CheckoutSkeleton} from "../atoms/effects/skeletons/checkout/CheckoutSkeleton";
import {DeliverySkeleton} from "../atoms/effects/skeletons/checkout/delivery/DeliverySkeleton";
import {PaymentSkeleton} from "../atoms/effects/skeletons/checkout/payment/PaymentSkeleton";
import {ConfirmationSkeleton} from "../atoms/effects/skeletons/checkout/confirmation/ConfirmationSkeleton";
import {ProductFinderSkeleton} from "../../atoms/effects/skeletons/finders/product-finder/ProductFinderSkeleton";
import {RecipeFinderSkeleton} from "../../atoms/effects/skeletons/finders/recipe-finder/RecipeFinderSkeleton";
import {ECOMVariationSkeleton} from "../../atoms/effects/skeletons/products/ECOMVariationSkeleton";
import {SearchFinderSkeleton} from "../../atoms/effects/skeletons/finders/search-finder/SearchFinderSkeleton";

export const WithSkeleton: FunctionComponent<IWithSkeleton> = ({loading, skeletonType, children}) => {

    const getSkeleton = () => {
        switch (skeletonType) {
            case SkeletonTypes.PRODUCTS:
                return <ProductSkeleton/>;
            case SkeletonTypes.ORDERS:
                return <OrderSkeleton/>;
            case SkeletonTypes.INVOICES:
                return <InvoiceSkeleton/>;
            case SkeletonTypes.FAVORITE_RECIPES:
                return <FavoriteRecipeSkeleton/>;
            case SkeletonTypes.DOCUMENTS:
                return <DocumentSkeleton/>;
            case SkeletonTypes.CONTRACTS:
                return <ContractSkeleton/>;
            case SkeletonTypes.CART:
                return <CartSkeleton/>;
            case SkeletonTypes.DELIVERY_NOTES:
                return <DeliveryNoteSkeleton/>;
            case SkeletonTypes.RECIPE_LIST:
                return <RecipeListSkeleton/>;
            case SkeletonTypes.CHECKOUT:
                return <CheckoutSkeleton/>;
            case SkeletonTypes.CHECKOUT_DELIVERY:
                return <DeliverySkeleton/>;
            case SkeletonTypes.CHECKOUT_PAYMENT:
                return <PaymentSkeleton/>;
            case SkeletonTypes.CHECKOUT_CONFIRMATION:
                return <ConfirmationSkeleton/>;
            case SkeletonTypes.PRODUCT_FINDER:
                return <ProductFinderSkeleton/>;
            case SkeletonTypes.RECIPE_FINDER:
                return <RecipeFinderSkeleton/>;
            case SkeletonTypes.SEARCH_FINDER:
                return <SearchFinderSkeleton/>;
            case SkeletonTypes.ECOM_VARIATION:
                return <ECOMVariationSkeleton/>;
        }
    }

    return (loading ?
            <div style={{width: "100%"}}>
                {getSkeleton()}
            </div>
            :
            <React.Fragment>
                {children}
            </React.Fragment>
    )
}
